import React from 'react'
import { useLanguageContext } from '../../contexts/LanguageContext'
import './Hero.css'
import SEO from '../seo/SEO'
import { Link } from "react-router-dom";

const Hero: React.FC = () => {
  const { content } = useLanguageContext()

  return (
    <>
      <SEO
        title={content.hero.seo.title}
        description={content.hero.seo.description}
      />
      <section id="hero" className="hero-section">
        <div className="container">
          <div className="hero-content">
            {/* Left side - Text content */}
            <div className="hero-text">
              <p className="hero-subtitle">{content.hero.subtitle}</p>
              <h1 className="hero-title">
                {content.hero.title}
              </h1>
              <p className="hero-description">
                {content.hero.description}
              </p>
              <div className="hero-buttons">
                <a className="btn btn-primary btn-medium" href="https://t.me/i_make_your_day_bot" target="_blank">
                  {content.hero.cta}
                </a>
                <Link to="/how-it-works" className="btn btn-secondary btn-medium play-demo">
                  <span className="play-icon">▶</span>
                  <span>{content.hero.playDemo}</span>
                </Link>
              </div>
            </div>

            {/* Right side - Visual elements */}
            <div className="hero-visual">
              <div className="hero-image-container">
                <img 
                  src="/assets/img/hero/cupe-bg.png" 
                  alt="Happy girl with positive energy" 
                  className="hero-image"
                />
                <div className="floating-elements">
                  <div className="floating-icon notification">🔔</div>
                  <div className="floating-icon heart">❤️</div>
                  <div className="floating-icon star">⭐</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        {/* Curved divider */}
        <div className="section-divider"></div>
      </section>
    </>
  )
}

export default Hero 